import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppService } from './app.service';

interface UrlMapper {
    offline: string;
    http: string;
}

@Injectable({
    providedIn: 'root',
})
export class UrlService {
    constructor(private appService: AppService) {}

    private endpoints: { [key: string]: (args?: any) => UrlMapper } = {
        'pdf.energyLabel.download': (args: any) => {
            return {
                offline: '',
                http: `energy/${this.appService.getSalesOrg()}/${this.appService.getLanguageOnly()}/pdf/${args.hash}`,
            };
        },
        'employee.languages': () => {
            return {
                offline: '',
                http: `employee`,
            };
        },
        'quote.cancelKeys': () => {
            return {
                offline: '',
                http: `quote/cancel-keys?language=${this.appService.getLanguageOnly()}`,
            };
        },
        'next-steps.attachments': (args: any) => {
            return {
                offline: '',
                http: `quote/${args.id}/revision/0/attachments`,
            };
        },
        'next-steps.attachment.delete': (args: any) => {
            return {
                offline: '',
                http: `quote/${args.quoteId}/revision/0/attachments/${args.attachmentId}`,
            };
        },
        'next-steps.attachment.download': (args: any) => {
            return {
                offline: '',
                http: `quote/${args.id}/revision/0/attachments/${args.documentUri}`,
            };
        },
        sendMailWithDocuments: (args: any) => {
            return {
                offline: '',
                http: `quote/${args.id}/revision/0/mail`,
            };
        },
        sendFeedback: () => {
            return {
                offline: '',
                http: `feedback`,
            };
        },
        validateVoucherCode: () => {
            return {
                offline: '',
                http: `voucher`,
            };
        },
    };

    public getUrl(name: string, args?: object): string {
        return environment.http.baseUrl + this.endpoints[name](args).http;
    }
}
